module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-17.ed9870e2.png";